import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Scroll-reveal, ported verbatim from the original bundle's `observe()`.
 *
 * Any element carrying `data-reveal` fades + rises into view (`@keyframes mhRise`)
 * the first time it scrolls near the viewport. Elements already in view on load
 * are never hidden. Re-runs on every route change. Safe on the server (no-ops
 * when there is no `window`/`IntersectionObserver`).
 */
export function useReveal() {
  const { pathname } = useLocation()
  useEffect(() => {
    if (typeof window === 'undefined' || !window.IntersectionObserver) return
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            ;(e.target as HTMLElement).style.animation =
              'mhRise .7s cubic-bezier(.2,.7,.3,1) both'
            io.unobserve(e.target)
          }
        })
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 },
    )
    const raf = requestAnimationFrame(() => {
      document.querySelectorAll<HTMLElement>('[data-reveal]').forEach((el) => {
        const r = el.getBoundingClientRect()
        if (el.hasAttribute('data-reveal-init')) {
          if (el.style.opacity === '0' && r.top < window.innerHeight) el.style.opacity = ''
          return
        }
        el.setAttribute('data-reveal-init', '1')
        if (r.top < window.innerHeight * 0.9) return
        el.style.opacity = '0'
        io.observe(el)
        setTimeout(() => {
          if (el.style.opacity === '0') el.style.opacity = ''
        }, 2500)
      })
    })
    return () => {
      cancelAnimationFrame(raf)
      io.disconnect()
    }
  }, [pathname])
}
